import { useCallback, useState, useEffect } from 'react';
let disableSSR = false;
export default function useNodeSize(ref, defaultSize = [240, 240]) {
    const [size, setSize] = useState(null);
    const handleRecalculate = useCallback(() => {
        const node = ref.current;
        if (node == null)
            return;
        const nodeSize = [node.clientWidth, node.clientHeight];
        setSize((size) => {
            if (size == null || nodeSize[0] > size[0] || nodeSize[1] > size[1]) {
                return [
                    Math.max(nodeSize[0], defaultSize[0]),
                    Math.max(nodeSize[1], defaultSize[1]),
                ];
            }
            return size;
        });
    }, [ref]);
    useEffect(() => {
        let initId = requestAnimationFrame(() => {
            initId = null;
            disableSSR = true;
            handleRecalculate();
        });
        let recalcTimeoutId = null;
        const handleResize = () => {
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            recalcTimeoutId = window.setTimeout(() => {
                recalcTimeoutId = null;
                handleRecalculate();
            }, 500);
        };
        let resizeObserver = null;
        const targetNode = ref.current;
        if (window.ResizeObserver != null && targetNode != null) {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(targetNode);
        }
        else {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (initId != null)
                cancelAnimationFrame(initId);
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            if (resizeObserver != null) {
                resizeObserver.disconnect();
            }
            else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [ref, handleRecalculate]);
    if (!disableSSR && size == null)
        return defaultSize;
    return size;
}
//# sourceMappingURL=useNodeSize.js.map